/* eslint-disable react/prop-types */
import React from 'react';
import { formatTokenCount } from '../../services/aiInsightsApi';

/**
 * Shell footer:
 * - Monthly quota bar when rag_qa returns { used, limit }
 * - Otherwise nothing (per-answer INPUT/OUTPUT/COST lives under each message)
 */
const SpacerLogAiQuotaBar = ({ quota }) => {
  if (!quota || !Number.isFinite(quota.used) || !Number.isFinite(quota.limit) || quota.limit <= 0) {
    return null;
  }
  const pct = Math.min(100, Math.max(0, (quota.used / quota.limit) * 100));
  return (
    <div className="spacer-ask-evans__quota">
      <span className="spacer-ask-evans__quota-label">
        Token usage: {formatTokenCount(quota.used)} / {formatTokenCount(quota.limit)}
      </span>
      <div className="spacer-ask-evans__quota-track" aria-hidden>
        <div className="spacer-ask-evans__quota-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default SpacerLogAiQuotaBar;
